import React, { useCallback, useMemo, useState } from 'react';
import { Redirect } from 'wouter';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { InfoView } from '../../ui/InfoView';
import { FadeIn } from '../../ui/Transitions';
import { useResolve } from '../Container';
import { ButtonStrip, FlexFrame, Spacer, ToggleFrame, ToggleLabel } from '../dashboard/elements/LayoutElements';
import { workspaceCreate } from '../workspace/WorkspaceCommands';
import { Button, Input, Toggle } from './../../ui';

const { Section, LargeHeading, } = InfoView;

export const ManageWorkspacesCreateView = () => {

    const dispatch = useResolve(CommandDispatcher);

    const [label, setLabel] = useState('');
    const [makePublic, setMakePublic] = useState(true);
    const [addSelf, setAddSelf] = useState(false);
    const [working, setWorking] = useState(false);
    const [result, setResult] = useState<any>();

    const inputs = useMemo(() => [label, '', addSelf, makePublic], [label, addSelf, makePublic]);

    const onCreate = useCallback(async () => {
        if (working) return;
        setWorking(true);
        setResult(await dispatch(workspaceCreate, inputs));
        setWorking(false);
    }, [inputs, working]);

    if (result) {
        return <Redirect to={`~/manage/workspaces/${result}`} />;
    }

    return <FadeIn>
        <FlexFrame>
            <Section>
                <LargeHeading>Create Workspace</LargeHeading>
            </Section>
            <Section>
                <Input placeholder="Workspace Name" value={label} onChange={x => setLabel(x)} />
                <Spacer f={3} />
                <ToggleFrame>
                    <Toggle value={makePublic} onAction={() => setMakePublic(x => !x)} />
                    <ToggleLabel>Make public</ToggleLabel>
                </ToggleFrame>
                <Spacer f={3} />
                <ToggleFrame>
                    <Toggle value={addSelf} onAction={() => setAddSelf(x => !x)} />
                    <ToggleLabel>Add yourself as a member</ToggleLabel>
                </ToggleFrame>
                <Spacer f={3} />
                <ButtonStrip>
                    <Button variant="primary" label="Create" onAction={onCreate} disabled={working} />
                </ButtonStrip>
            </Section>
        </FlexFrame>
    </FadeIn>;
};
